// The API returns decimal strings: keep kopecks exact even for large totals.
export function expenseMoney(value) {
  if (value == null || !/^-?\d+(\.\d{1,2})?$/.test(String(value))) return '—';
  const [whole, fraction = ''] = String(value).split('.');
  return `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0')},${fraction.padEnd(2, '0')} ₽`;
}
